import { render, staticRenderFns } from "./ConsumerProfile.vue?vue&type=template&id=424ebc7c&scoped=true&"
import script from "./ConsumerProfile.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfile.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerProfile.vue?vue&type=style&index=0&id=424ebc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ebc7c",
  null
  
)

export default component.exports